import { IpDTOV1 } from '../swagger-api-v1';

export class IpMapping {
  constructor(
    public id: number,
    public ip: string
  ) {}

  public static fromDTO(dto: IpDTOV1): IpMapping {
    return new IpMapping(dto.id, dto.ip);
  }
}
